var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPPrevPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 12L8.79289 11.2929L8.08579 12L8.79289 12.7071L9.5 12ZM14.7929 5.29289L8.79289 11.2929L10.2071 12.7071L16.2071 6.70711L14.7929 5.29289ZM8.79289 12.7071L14.7929 18.7071L16.2071 17.2929L10.2071 11.2929L8.79289 12.7071Z",
    fill: "#F5F5F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPPrevPurple);
export default __webpack_public_path__ + "static/media/pPrev_purple.c7c859be423f795024a6e0479ecc5773.svg";
export { ForwardRef as ReactComponent };